import script from "./SidebarNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavigator.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNavigator.vue?vue&type=style&index=0&id=3b3e5d0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3e5d0c"]])

export default __exports__